import styled from 'styled-components';

interface DescriptionMessageInterventionProps {
  isBanner: number;
}

interface InterventionContainerProps {
  isBanner: boolean;
}

interface HasInconsistency {
  hasInconsistency: boolean;
}

export const Content = styled.div<HasInconsistency>`
  padding: 14px 14px;
  margin-top: 8%;
  margin-bottom: 0;
  border: ${props =>
    props.hasInconsistency ? '1px solid red' : ' 1px solid #005cde'};
  display: flex;
  border-radius: 3px;

  @media (max-width: 650px) {
    display: grid;
    grid-template-columns: 16px 2fr;
    width: 320px;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const IconAlert = styled.img`
  padding: 0;
  margin-top: 0.8%;
  width: 20px;
  height: 20px;

  @media (max-width: 650px) {
    padding: 0;
    margin-top: 4px;
    width: 20px;
    height: 20px;
  }
`;

export const PopUpMessageIntervention = styled.div`
  padding: 0;
  margin-top: 0.2%;
  margin-bottom: 0;
  margin-left: 2%;
  margin-right: 2vw;

  @media (max-width: 650px) {
    padding: 0;
    margin-top: -0.4%;
    margin-bottom: 0;
    margin-left: 14px;
    margin-right: 3vw;
  }
`;

export const TitleMessageIntervention = styled.h1<HasInconsistency>`
  padding: 0;
  margin: 0;
  left: 0px;
  top: 0px;
  margin-bottom: 4px;
  color: ${props => (props.hasInconsistency ? 'red' : '#005cde')};
  height: 18px;
  width: 430px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;

  @media (max-width: 650px) {
    padding: 0;
    margin: 0;
    margin-left: 4px;
    margin-bottom: 4px;
    left: 0px;
    top: 0px;
    color: #005cde;
    height: 35px;
    width: 230px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 11.4pt;
  }
`;

export const DescriptionMessageIntervention = styled.p<DescriptionMessageInterventionProps>`
  padding: 0;
  margin: 0;
  width: ${props => (props.isBanner > 420 ? '500px' : '420px')};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #333333;

  @media (max-width: 650px) {
    padding: 0;
    margin: 0;
    margin-left: 4px;
    margin-bottom: 6px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 9.8pt;
    line-height: 17px;
    width: 240px;
    color: #333333;
  }
`;

export const ButtonIntervention = styled.button`
  padding: 0;
  height: 40px;
  padding: 8px 16px;
  border: none;
  background-color: #005cde;
  color: white;
  border-radius: 4px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  margin: 10px;

  @media (max-width: 650px) {
    padding: 0;
    margin-bottom: 0;
    margin-top: 6px;
    margin-left: 32px;
    height: 40px;
    width: 108px;
    padding: 2px 10px;
    border: none;
    background-color: #005cde;
    color: white;
    border-radius: 4px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 7px;
  }
`;

export const PopUpContainer = styled.div<InterventionContainerProps>`
  display: contents;
`;
